<template>
    <div class="waba-error-codes">
        <div class="search-container">
            <a-input v-model="searchQuery" placeholder="Hata mesajı ara..." :allowClear="true">
                <a-icon slot="prefix" type="search" />
            </a-input>
        </div>
        <a-collapse v-model="activeKey" accordion>
            <a-collapse-panel v-for="(error, index) in filteredErrors" :key="index" :header="error.originalError">
                <div class="error-description">
                    <div class="description-tr">
                        <strong>🇹🇷 Türkçe:</strong>
                        <p>{{ error.descriptions.tr }}</p>
                    </div>
                    <div class="description-en">
                        <strong>🇬🇧 English:</strong>
                        <p>{{ error.descriptions.en }}</p>
                    </div>
                    <a-alert class="meta-link-alert" type="info" show-icon>
                        <template #message>
                            <span>
                                Daha fazla detay için
                                <a
                                    href="https://developers.facebook.com/docs/whatsapp/cloud-api/support/error-codes/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Meta'yı ziyaret edin
                                </a>
                            </span>
                        </template>
                    </a-alert>
                </div>
            </a-collapse-panel>
        </a-collapse>
    </div>
</template>

<script>
export default {
    name: "WABAErrorCodes",
    props: {
        defaultSelectedError: {
            type: String,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            searchQuery: "",
            activeKey: null,
            wabaErrors: [
                {
                    originalError:
                        "OAuthException, (#132015) Template is temporarily unavailable to use because it was paused due to low quality.",
                    descriptions: {
                        tr: "Bu hata, şablonun düşük kalite nedeniyle geçici olarak devre dışı bırakıldığını belirtir. Genellikle kullanıcılar tarafından düşük puanlanma veya sık sık reddedilme nedeniyle oluşur. Çözüm için şablonun içeriğini gözden geçirin ve daha kaliteli hale getirin.",
                        en: "This error indicates that the template has been temporarily disabled due to low quality. It usually occurs due to low user ratings or frequent rejections. Review the template content and improve its quality to resolve this.",
                    },
                },
                {
                    originalError: "OAuthException, (#132005) Translated text too long",
                    descriptions: {
                        tr: "Çevirilen metnin çok uzun olduğunu belirtir. Mesaj uzunluğunu azaltarak daha kısa ve öz bir metin oluşturun.",
                        en: "Indicates that the translated text is too long. Shorten the message to make it concise and within limits.",
                    },
                },
                {
                    originalError: "OAuthException, (#131008) Required parameter is missing",
                    descriptions: {
                        tr: "Gerekli bir parametrenin eksik olduğunu gösterir. API dokümantasyonunu kontrol ederek eksik parametreleri tamamlayın.",
                        en: "Indicates that a required parameter is missing. Check the API documentation and include the missing parameters.",
                    },
                },
                {
                    originalError: "OAuthException, (#100) The parameter text['body'] is required.",
                    descriptions: {
                        tr: "'text[\"body\"]' parametresi zorunludur. Mesaj metnini eklediğinizden emin olun.",
                        en: "The 'text[\"body\"]' parameter is required. Ensure you include the message text.",
                    },
                },
                {
                    originalError: "Spam Rate limit hit",
                    descriptions: {
                        tr: "Mesaj gönderim sıklığınız sınırı aştı. Gönderim oranınızı azaltın.",
                        en: "Your message sending frequency exceeded the limit. Reduce your sending rate.",
                    },
                },
                {
                    originalError:
                        "GraphMethodException, Unsupported post request. Object with ID '314167035111669' does not exist, cannot be loaded due to missing permissions, or does not support this operation.",
                    descriptions: {
                        tr: "Belirtilen ID mevcut değil veya gerekli izinler eksik. ID ve izinleri kontrol edin.",
                        en: "The specified ID does not exist or the required permissions are missing. Check the ID and permissions.",
                    },
                },
                {
                    originalError: "Message undeliverable",
                    descriptions: {
                        tr: "Mesaj alıcıya teslim edilemedi. Alıcı geçersiz bir whatsapp numarası olabilir veya alıcı whatsapp gizlilik sözleşmesini kabul etmemiş olabilir.",
                        en: "The message could not be delivered to the recipient. The recipient may have an invalid WhatsApp number or may not have accepted the WhatsApp privacy policy.",
                    },
                },
                {
                    originalError: "OAuthException, (#100) Invalid parameter",
                    descriptions: {
                        tr: "Geçersiz bir parametre gönderildi. Parametre formatını kontrol edin.",
                        en: "An invalid parameter was sent. Check the parameter format.",
                    },
                },
                {
                    originalError: "Media upload error",
                    descriptions: {
                        tr: "Medya yükleme sırasında bir sorun oluştu. Dosya boyutunu ve formatını kontrol edin.",
                        en: "An issue occurred during media upload. Check the file size and format.",
                    },
                },
                {
                    originalError: "User's number is part of an experiment",
                    descriptions: {
                        tr: "Alıcı numarası bir deneyin parçası. Mesaj gönderimini bir süre sonra yeniden deneyin.",
                        en: "The recipient's number is part of an experiment. Try sending the message again later.",
                    },
                },
                {
                    originalError: "OAuthException, (#131053) Media upload error",
                    descriptions: {
                        tr: "Medya yükleme sırasında bir hata oluştu. Medya formatını ve boyutunu doğrulayın.",
                        en: "A media upload error occurred. Validate the media format and size.",
                    },
                },
                {
                    originalError: "OAuthException, (#2) Service temporarily unavailable",
                    descriptions: {
                        tr: "Hizmet geçici olarak kullanılamıyor. Daha sonra tekrar deneyin.",
                        en: "The service is temporarily unavailable. Please try again later.",
                    },
                },
                {
                    originalError: "OAuthException, (#200) You do not have permission to access this field.",
                    descriptions: {
                        tr: "Bu alana erişim izniniz yok. Gerekli izinlerin verildiğinden emin olun.",
                        en: "You do not have permission to access this field. Ensure the required permissions are granted.",
                    },
                },
                {
                    originalError: "Business Account locked",
                    descriptions: {
                        tr: "İşletme hesabınız kilitlenmiş. Hesabınızı tekrar etkinleştirmek için destek ekibiyle iletişime geçin.",
                        en: "Your business account is locked. Contact support to reactivate your account.",
                    },
                },
                {
                    originalError: "This message was not delivered to maintain healthy ecosystem engagement.",
                    descriptions: {
                        tr: "Mesaj sağlıklı bir ekosistem için teslim edilmedi. Mesaj içeriğinizi ve sıklığınızı gözden geçirin. Alıcıya belli bir zaman aralığında bir kaç tane marketing template atabilirsiniz daha fazlasına izin verilmez.",
                        en: "The message was not delivered to maintain a healthy ecosystem. Review your message content and frequency. You can send a few marketing templates to the recipient within a certain time interval, but more than that is not allowed.",
                    },
                },
                {
                    originalError: "Re-engagement message",
                    descriptions: {
                        tr: "Alıcıyla yeniden etkileşim mesajı gönderilemedi. Alıcının katılım onayını doğrulayın.",
                        en: "The re-engagement message could not be sent. Verify the recipient's opt-in status.",
                    },
                },
                {
                    originalError: "OAuthException, (#135000) Generic user error",
                    descriptions: {
                        tr: "Genel bir kullanıcı hatası oluştu. API isteğinizi kontrol edin.",
                        en: "A generic user error occurred. Check your API request.",
                    },
                },
                {
                    originalError: "Business eligibility payment issue",
                    descriptions: {
                        tr: "İşletme uygunluk ödemesiyle ilgili bir sorun var. Fatura ve ödeme ayarlarını kontrol edin.",
                        en: "There is an issue with business eligibility payment. Check your billing and payment settings.",
                    },
                },
                {
                    originalError: "Generic user error",
                    descriptions: {
                        tr: "Genel bir kullanıcı hatası oluştu. Detaylı bilgi için hata kodlarını kontrol edin.",
                        en: "A generic user error occurred. Check error codes for more details.",
                    },
                },
                {
                    originalError:
                        "OAuthException, (#131037) WhatsApp provided number needs display name approval before message can be sent.",
                    descriptions: {
                        tr: "WhatsApp numarası için görüntüleme adı onayı gerekiyor. Onay işlemini tamamlayın.",
                        en: "The WhatsApp number requires display name approval before messages can be sent. Complete the approval process.",
                    },
                },
                {
                    originalError:
                        "OAuthException, (#132000) Number of parameters does not match the expected number of params",
                    descriptions: {
                        tr: "Gönderilen parametre sayısı beklenenle eşleşmiyor. Parametrelerinizi doğrulayın.",
                        en: "The number of parameters does not match the expected count. Verify your parameters.",
                    },
                },
            ],
        };
    },
    computed: {
        filteredErrors() {
            if (!this.searchQuery) return this.wabaErrors;

            const query = this.searchQuery.toLowerCase();
            return this.wabaErrors.filter(
                (error) =>
                    error.originalError.toLowerCase().includes(query) ||
                    error.descriptions.tr.toLowerCase().includes(query) ||
                    error.descriptions.en.toLowerCase().includes(query)
            );
        },
    },
    created() {
        if (this.defaultSelectedError) {
            const index = this.wabaErrors.findIndex(error => {
                return error.originalError.trim().toLowerCase() === this.defaultSelectedError.trim().toLowerCase();
            });
            if (index !== -1) {
                this.activeKey = index;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.waba-error-codes {
    padding: 20px;
    max-height: 70vh;
    overflow-y: auto;

    .search-container {
        margin-bottom: 16px;

        :deep(.ant-input-affix-wrapper) {
            background-color: var(--color-bg-neutral-default);
            border: 1px solid var(--color-border-default);

            .ant-input {
                background-color: var(--color-bg-neutral-default);
                color: var(--color-text-default);

                &::placeholder {
                    color: var(--color-text-disabled);
                }
            }
        }
    }

    .error-description {
        display: flex;
        flex-direction: column;
        gap: 16px;

        .description-tr,
        .description-en {
            display: flex;
            flex-direction: column;
            gap: 8px;

            strong {
                font-size: 14px;
                color: var(--color-text-strong-default);
            }

            p {
                margin: 0;
                font-size: 14px;
                line-height: 1.5;
                color: var(--color-text-default);
            }
        }

        .meta-link-alert {
            margin-top: 16px;

            :deep(a) {
                color: var(--color-primary-default);
                text-decoration: none;

                &:hover {
                    text-decoration: underline;
                }
            }
        }
    }

    :deep(.ant-collapse) {
        background-color: var(--color-bg-neutral-default);
        border: 1px solid var(--color-border-default);
        border-radius: 4px;
    }

    :deep(.ant-collapse-header) {
        font-size: 14px;
        color: var(--color-text-strong-default) !important;
    }

    :deep(.ant-collapse-content) {
        background-color: var(--color-bg-neutral-low-default);
    }
}
</style>
